import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import {AppThunk} from 'state';
import {formatReviews} from 'helpers/reviewFormatter';
import {ReviewItem, ReviewClassName} from './types';
import * as Parse from 'parse';

interface State {
  error: string | null;
  fetchLoading: boolean;
  addLoading: boolean;

  reviews: ReviewItem[] | null;
}

const initialState: State = {
  error: null,
  fetchLoading: false,
  addLoading: false,

  reviews: [],
};

const reviewsSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    fetchReviewsStart(state) {
      state.fetchLoading = true;
      state.error = null;
      state.reviews = null;
    },
    fetchReviewsSuccess(state, action: PayloadAction<ReviewItem[]>) {
      state.fetchLoading = false;
      state.reviews = action.payload;
    },
    fetchReviewsFailed(state, action: PayloadAction<string>) {
      state.fetchLoading = false;
      state.error = action.payload;
    },
    // Add other review-related reducers as needed
    reset(state) {
      state.fetchLoading = false;
      state.addLoading = false;
      state.error = null;
      state.reviews = null;
    },

    purge() {
      return initialState;
    },
  },
});

export const {
  fetchReviewsStart,
  fetchReviewsSuccess,
  fetchReviewsFailed,
  // Add other review-related actions here
  reset,

  purge,
} = reviewsSlice.actions;

export default reviewsSlice.reducer;

/**
 * Thunks
 */

export const fetchReviewsData =
  (waiterId: string): AppThunk =>
  async (dispatch) => {
    try {
      const query = new Parse.Query(ReviewClassName);
      query.equalTo(
        'waiter',
        Parse.Object.extend('Waiter').createWithoutData(waiterId),
      );
      query.include('user');
      const reviews = await query.find();
      dispatch(fetchReviewsSuccess(formatReviews(reviews)));
    } catch (error) {
      Sentry.captureException(error);
      console.error('fetchReviews error', error);
    }
  };
